var map = {
	"./logos/ABS.png": 4746,
	"./logos/Acindar.png": 7800,
	"./logos/Adecoagro.png": 690,
	"./logos/Adidas.png": 1194,
	"./logos/Allflex.png": 2357,
	"./logos/Arawak.png": 2726,
	"./logos/Arla.png": 9992,
	"./logos/BaronB.png": 84,
	"./logos/Chandon.png": 9745,
	"./logos/Citroen.png": 5862,
	"./logos/Dakar.png": 6987,
	"./logos/Gentos.png": 8335,
	"./logos/Heineken.png": 1986,
	"./logos/LaGloriosa.png": 2516,
	"./logos/LaProvidencia.png": 2474,
	"./logos/MSD.png": 4763,
	"./logos/Nissan.png": 8714,
	"./logos/Quilmes.png": 7978,
	"./logos/Samsung.png": 4300,
	"./logos/Santander.png": 7957,
	"./logos/Shell.png": 6397,
	"./logos/TNC.png": 6097,
	"./logos/VeuveClicquot.png": 4306,
	"./logos/WeGolf.png": 616,
	"./logos/YPF.png": 2344,
	"./logos/directv.png": 6850,
	"./logos/domPerignon.png": 4005,
	"./logos/hatsu.png": 263,
	"./logos/hsbc.png": 4698
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1105;